import { render, staticRenderFns } from "./Bcar.vue?vue&type=template&id=8e51472e&scoped=true&"
import script from "./Bcar.vue?vue&type=script&lang=js&"
export * from "./Bcar.vue?vue&type=script&lang=js&"
import style0 from "./Bcar.vue?vue&type=style&index=0&id=8e51472e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e51472e",
  null
  
)

export default component.exports